import { Lexicon } from '@familyhub/shared';
import targetWords from './data/target-words.json';
import validWords from './data/valid-words.json';
import targetSpellings from './data/target-spellings.json';

/**
 * The module's lexicon, built once from the committed Dutch word lists (spec §4).
 *
 * Generated by `web/scripts/build-wordle-words.mjs` from the official
 * Woordenlijst (every guess) gated by word prevalence and Wiktionary (the
 * answers), normalized with the very same `normalize` the engine uses, so a
 * typed word and a stored word fold to the same key. See docs/WORDLE.md §4.
 */
export const TARGET_WORDS = targetWords as string[];
export const VALID_WORDS = validWords as string[];

export const LEXICON = new Lexicon({ targets: TARGET_WORDS, valid: VALID_WORDS });

const SPELLINGS = targetSpellings as Record<string, string>;

/**
 * The answer in its official spelling (`zeeën` for ZEEEN, `naïef` for NAIEF).
 * The board folds accents away, which is right for typing and wrong for two
 * things: showing the answer, and looking up its meaning — `zeeen` is not a page
 * Wiktionary has. Lower-case; the board's own fold for every other word.
 */
export function spelledAnswer(target: string): string {
  return SPELLINGS[target] ?? target.toLowerCase();
}
